/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Directive, ElementRef, Inject, OnDestroy, OnInit, Self } from '@angular/core';

@Directive({
  selector: '[fmVirtualScrollViewportResize], fm-virtual-scroll-viewport-resize'
})
export class VirtualScrollViewportResizeDirective implements OnInit, OnDestroy {
  private _resizeCheckInterval: NodeJS.Timeout;
  private _previousElementRefBounds: DOMRect;
  constructor(
    @Self()
    @Inject(CdkVirtualScrollViewport)
    private readonly _viewport: CdkVirtualScrollViewport,
    private readonly _elementRef: ElementRef
  ) {}

  ngOnInit() {
    this._resizeCheckInterval = setInterval(() => {
      const bounds = (this._elementRef.nativeElement as HTMLElement).getBoundingClientRect();
      if (!this._previousElementRefBounds || bounds !== this._previousElementRefBounds) {
        this._viewport.checkViewportSize();
      }
      this._previousElementRefBounds = bounds;
    }, 500);
  }

  ngOnDestroy() {
    clearInterval(this._resizeCheckInterval);
  }
}
